import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('App error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', fontFamily: 'sans-serif',
          background: '#f9f9f9', color: '#333', textAlign: 'center', padding: '2rem'
        }}>
          <h2 style={{ marginBottom: '1rem' }}>Something went wrong</h2>
          <p style={{ color: '#666', marginBottom: '1.5rem' }}>
            An unexpected error occurred. Please refresh the page or contact support.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: '10px 24px', background: '#2E75B6', color: '#fff',
              border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px'
            }}
          >
            Refresh page
          </button>
          {process.env.NODE_ENV !== 'production' && (
            <pre style={{
              marginTop: '2rem', padding: '1rem', background: '#fff',
              border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px',
              textAlign: 'left', maxWidth: '600px', overflow: 'auto',
              color: '#c00'
            }}>
              {this.state.error?.toString()}
            </pre>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
